import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('tax', 'el impuesto', 'los impuestos')

const getTaxes = (options) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/tax/utils/get_taxes`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})
		dispatch({
			type: 'LOAD_TAXS',
			response: res.body,
		})
		return res.body
	}
}

const createTaxes = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/tax/create_taxes`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),

			successMessage: 'Se agregó el impuesto correctamente.',
		})

		dispatch({
			type: 'ADD_TAX',
			response: res.body,
		})

		return res.body
	}
}

const updateTaxes = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/tax/update_taxes`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),

			successMessage: 'Se actualizó el impuesto correctamente.',
		})

		dispatch({
			type: 'UPDATE_TAX',
			response: res.body,
		})

		return res.body
	}
}

const getTaxesById = (id) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/tax/utils/get_taxes/${id}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})
		dispatch({
			type: 'LOAD_TAX',
			response: res.body,
			payload: id
		})
		return res.body
	}
}

const deleteTaxes = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/tax/utils/delete_taxes`, {
			method: 'DELETE',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),

			successMessage: 'Se eliminó el impuesto correctamente.',
		})

		dispatch({
			type: 'DELETE_TAX',
			response: res.body,
		})

		return res.body
	}
}

export default {
	...actions,
	get: getTaxesById,
	getTaxes,
	createTaxes,
	updateTaxes,
	getTaxesById,
	deleteTaxes,
}
